import { api, handleError } from "./baseApi";

export async function getAllTransactions(filters = {}) {
  try {
    const { data } = await api.get("/transactions", {
      params: filters,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function deleteTransaction(id) {
  try {
    const { data } = await api.delete(`/transactions/${id}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function updateTransaction(id, payload) {
  try {
    const { data } = await api.put(`/transactions/${id}`, payload);
    return data;
  } catch (error) {
    return handleError(error);
  }
}

